/**
 * Available sort fields matching Koha biblio columns.
 * 'relevance' is a virtual field — when selected, no _order_by is sent,
 * letting Koha use its default relevance ranking.
 */
export type SortField = 'relevance' | 'title' | 'author' | 'copyright_date' | 'biblio_id';

/** Sort direction */
export type SortDirection = 'asc' | 'desc';

/** Current sort state */
export interface SortState {
  field: SortField;
  direction: SortDirection;
}

/** Default sort — relevance descending (Koha's default ranking) */
export const DEFAULT_SORT: SortState = {
  field: 'relevance',
  direction: 'desc',
};

/**
 * Sort option definitions for the sort control dropdown.
 * Each option maps to a Koha API field.
 */
export const SORT_OPTIONS: { field: SortField; labelKey: string }[] = [
  { field: 'relevance', labelKey: 'SORT.RELEVANCE' },
  { field: 'title',     labelKey: 'SORT.TITLE' },
  { field: 'author',    labelKey: 'SORT.AUTHOR' },
  { field: 'copyright_date', labelKey: 'SORT.DATE' },
];
